import React from 'react';

import { List } from '@mui/material';

import { useLocation } from '@/hooks/useLocation';

import { SidebarMenuListItem } from './SidebarMenuListItem';
import { SidebarMenuItem } from './SidebarMenuListItem.types';

export interface SidebarMenuListProps {
    items: SidebarMenuItem[];
    isStatisticsLoading: boolean;
    active?: string;
}

export const SidebarMenuList = ({ items, isStatisticsLoading }: SidebarMenuListProps) => {
    const { pathname } = useLocation();

    return (
        <List sx={{ padding: 0 }}>
            {items.map((item) => (
                <SidebarMenuListItem
                    key={item.id}
                    className="sidebar-menu-item"
                    isStatisticsLoading={isStatisticsLoading}
                    selected={pathname === item.pathname}
                    {...item}
                />
            ))}
        </List>
    );
};
